// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-21urm";
var _5 = "img-3AnQ9";
var _6 = "actions-3swbh";
var _7 = "paper-3zAgc";
var _8 = "paper_width_lg-1gsZQ";
var _9 = "paper_scroll_body-vSCUr";
var _a = "slideBottom_container-3puPG";
var _b = "modal_title-4aD-N";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "img", _6 as "actions", _7 as "paper", _8 as "paper_width_lg", _9 as "paper_scroll_body", _a as "slideBottom_container", _b as "modal_title" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "img": _5, "actions": _6, "paper": _7, "paper_width_lg": _8, "paper_scroll_body": _9, "slideBottom_container": _a, "modal_title": _b }
